import {Component, Input, EventEmitter, Output, ChangeDetectionStrategy, OnDestroy, OnInit} from '@angular/core';
import { NotifyService } from '@solar/components/notificationsview/notify.service';
import { Subscription } from 'rxjs';
import { Notification } from './notification.model';

@Component({
    selector: 'frms-notificationview',
    templateUrl: './notificationview.component.html',
    styleUrls: ['./notificationview.component.scss']
})
export class NotificationViewComponent implements OnInit, OnDestroy {


    notifications: Notification[];
    notificationSub: Subscription;

    @Output() onNewsHide: EventEmitter<any> = new EventEmitter();

    constructor(
        private notificationService:NotifyService
    ) { 
    }

    ngOnInit() {
    	this.notificationSub = this.notificationService.notifications$.subscribe((notifications) => {
            this.notificationHandler(notifications);
        });
     }

    ngOnDestroy() {
        this.notificationSub.unsubscribe();
    }

    hideNews(item){

    }

    notificationHandler(notifications){
        //simple order
        this.notifications = notifications.sort((a, b) => b.date.valueOf() - a.date.valueOf());
    }
    
}